import { LinearProgress } from '@mui/material'
import React from 'react'

type Props = {
    value: number
    max: number
    min: number
    width: number
}
const ProgressBar = ({ value, max, min, width }: Props) => {
    const normalise = (value: number) => ((value - min) * 100) / (max - min)

    const progressBarStyle = {
        width: `${width}%`,
        backgroundColor: 'custom.darkGray',
        '& .MuiLinearProgress-bar': {
            backgroundColor: 'custom.lightGray',
        },
        height: '3px',
    }
    return (
        <LinearProgress
            sx={progressBarStyle}
            variant="determinate"
            value={normalise(value)}
        />
    )
}
export { ProgressBar }
